import React from "react";
import {
  Typography,
  Box,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Divider,
  Paper,
} from "@mui/material";
import { useTranslation } from "react-i18next";
// import { Target } from '@mui/icons-material';

const InfoPurposeXs = ({ id }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        mt: 2,
        mb: 2,
        maxWidth: "100%",
        overflow: "hidden",
      }}
      id={id}
    >
      <Card
        elevation={0}
        sx={{
          borderRadius: 2,
          backgroundColor: "white",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          overflow: "hidden",
        }}
      >
        <CardContent sx={{ p: 0 }}>
          {/* Header */}
          <Box
            sx={{
              p: 2,
              display: "flex",
              alignItems: "center",
              borderBottom: "1px solid rgba(0,0,0,0.05)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 32,
                height: 32,
                borderRadius: "50%",
                color: "#007AFF",
              }}
            >
              <i
                className="fas fa-bullseye fa-2x"
                style={{ color: "#0c4d96" }}
              ></i>
            </Box>
            <Typography
              variant="subtitle1"
              component="h2"
              fontWeight="600"
              sx={{ ml: 1.5 }}
            >
              {t("privacy-policy.info-purpose.title")}
            </Typography>
          </Box>

          {/* Description */}
          <Box sx={{ p: 2, pt: 1.5 }}>
            <Typography
              variant="body2"
              sx={{
                color: "#666",
                mb: 2,
              }}
            >
              {t("privacy-policy.info-purpose.intro")}
            </Typography>
          </Box>

          {/* Purpose list in iOS style */}
          <List disablePadding>
            {t("privacy-policy.info-purpose.purposes", {
              returnObjects: true,
            }).map((purpose, index, array) => (
              <React.Fragment key={index}>
                <ListItem
                  alignItems="flex-start"
                  sx={{
                    px: 2,
                    py: 1.5,
                  }}
                >
                  <ListItemText
                    primary={purpose}
                    primaryTypographyProps={{
                      variant: "body2",
                      sx: { color: "#333" },
                    }}
                    sx={{
                      m: 0,
                      "&::before": {
                        content: `"${index + 1}. "`,
                        fontWeight: 500,
                        color: "#007AFF",
                      },
                    }}
                  />
                </ListItem>
                {index < array.length - 1 && (
                  <Divider variant="inset" component="li" sx={{ ml: 2 }} />
                )}
              </React.Fragment>
            ))}
          </List>

          {/* Note */}
          <Box
            component={Paper}
            variant="outlined"
            square
            sx={{ p: 2, pt: 1, borderRadius: 4 }}
          >
            <Typography
              variant="caption"
              sx={{
                display: "block",
                color: "#8E8E93",
              }}
            >
              {t("privacy-policy.info-purpose.note")}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default InfoPurposeXs;
